"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultResultItemDetail = void 0;
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
exports.defaultResultItemDetail = __assign(__assign({}, ResultPageState_init_1.defaultResultItems[0]), { sold: false, layout: 'Duplex', buildingRise: 'High Rise', description: 'One reason (as others have already touched) is likely to be lack of awareness. It could also be (as in my own case), a wish to keep the number of approaches to do similar things in a code base down as much as possible. So I tend to use the ternary operator for all compact if-a-condition-is-met-do-this-otherwise-do-that situations.', 
    // 'One reason',
    parkingUncoveredCount: 3, parkingUncoveredInclude: true, parkingCoveredCount: 2, parkingCoveredInclude: null, isSaleSubjectToOffer: false, isLeaseSubjectToOffer: false });
